<template>

<core-dropdown class="input" trigger="manual" v-on:forceClose="is.expanded = false" :expanded="is.expanded" v-click-outside="onOutsideClick" v-if="can.export">

	<core-button v-on:click.native="onToggleClick" theme="filter" tooltip="Export" :caret="true" icon="cloud-arrow-down" :iconOnly="$isDesktop" :iconLeft="$isMobile" text="Export" />
	
	<core-dropdown-list title="Export" :expanded="is.expanded" :caret="true" theme="filter" class="input-options" align="left" type="button" v-propagation v-on:close="is.expanded = false">

		<core-dropdown-item type="link" v-on:click.native="onExportCSVClick" :loading="is.exporting">As CSV</core-dropdown-item>
		<core-dropdown-item type="link" v-on:click.native="onExportClipboardClick" :loading="is.copying">To Clipboard</core-dropdown-item>

	</core-dropdown-list>

</core-dropdown>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: [
		'filter', 'page'
	],
	
	data: function() {

		return {
			is: {
				expanded: false,
				copying: false,
				exporting: false
			}
		}

	},

	created: function() {

		this.$pubsub.$on('presets.open', this.onOutsideClick.bind(this))
		this.$pubsub.$on('plays.expand', this.onOutsideClick.bind(this))
		this.$pubsub.$on('collection.expand', this.onOutsideClick.bind(this))

	},

	beforeDestroy: function() {

		this.$pubsub.$off('presets.open', this.onOutsideClick.bind(this))
		this.$pubsub.$off('plays.expand', this.onOutsideClick.bind(this))
		this.$pubsub.$off('collection.expand', this.onOutsideClick.bind(this))

	},

	computed: {

		can: function() {

			return this.$store.getters['service/select/can']

		}

	},

	methods: {

		onExportCSVClick: function(e) {

			e.stopPropagation()

			this.is.exporting = true

			this.$store.dispatch('service/select/export/csv').then(function() {

				this.is.exporting = false

			}.bind(this))

		},

		onExportClipboardClick: function(e) {

			e.stopPropagation()

			this.is.copying = true

			this.$store.dispatch('service/select/export/clipboard').then(function() {

				this.is.copying = false

			}.bind(this))

		},

		onTagsClick: function(e) {

			e.stopPropagation()

			this.$pubsub.$emit('open.modal', 'tagManage')

			this.onOutsideClick()

		},

		onToggleClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onOutsideClick: function() {

			this.is.expanded = false

		}

	}

}

</script>

<style scoped>

</style>
